"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchPreviewProduct = void 0;
var _analyticsData = require("@ori/analytics-data");
var _environment = require("@ori/environment");
var _presentationComponents = require("@ori/presentation-components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _SearchPreviewImage = require("../SearchPreviewImage");
var _components = require("./components");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SearchPreviewProduct = ({
  index,
  code,
  name,
  brand,
  image,
  deal,
  ppa,
  onProductClick,
  onQuickBuyButtonClick,
  price,
  searchPhrase,
  canBeSold = true,
  shades
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(_constants.SEARCH_PREVIEW_PRODUCT),
    onClick: onProductClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_SearchPreviewImage.SearchPreviewImage, {
      name: name,
      imageUrl: image
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Info, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.ProductInfo, {
          brand: brand,
          name: name,
          searchPhrase: searchPhrase,
          shades: shades,
          code: code,
          deal: deal,
          ppa: ppa
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.PriceAndButton, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Price, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Prices, {
            price: price,
            code: code
          })
        }), canBeSold ? /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.QuickBuyButton, {
            tenant: tenant,
            currentProductCode: code,
            name: name,
            placement: _analyticsData.Placement.TopNavigationSearchSuggestions,
            currentPrice: price?.currentFormatted ?? '',
            position: index,
            onQuickBuyButtonClick: onQuickBuyButtonClick
          })
        }) : null]
      })]
    })]
  });
};
exports.SearchPreviewProduct = SearchPreviewProduct;
